import { render } from "./RichText.vue?vue&type=template&id=161bb1c6&scoped=true"
import script from "./RichText.vue?vue&type=script&lang=js"
export * from "./RichText.vue?vue&type=script&lang=js"

import "./RichText.vue?vue&type=style&index=0&id=161bb1c6&lang=less&scoped=true"
import "./RichText.vue?vue&type=style&index=1&id=161bb1c6&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-161bb1c6"]])

export default __exports__